import React from 'react';
import { useTranslation } from 'react-i18next';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import './PaiementKo.scss';

const PaiementKo = ({
    onClose,
}) => {
    const { t } = useTranslation();
    return (
        <div>
            <DialogContent>
                <DialogContentText>
                    {t('votre-paiement-a-echoue')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {t('fermer')}
                </Button>
            </DialogActions>
        </div>
    );
};

export default PaiementKo;
